import { render, staticRenderFns } from "./Comingsoon_NLT.vue?vue&type=template&id=5188d48b&scoped=true&"
import script from "./Comingsoon_NLT.vue?vue&type=script&lang=js&"
export * from "./Comingsoon_NLT.vue?vue&type=script&lang=js&"
import style0 from "./Comingsoon_NLT.vue?vue&type=style&index=0&id=5188d48b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5188d48b",
  null
  
)

export default component.exports